var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CardContainer", {
        attrs: { title: _vm.companyName, subtitle: _vm.jobTitle },
        on: { update: _vm.showModal, remove: _vm.removeExperience },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("CardItem", {
                  attrs: { title: "Start Date", content: _vm.startDate },
                }),
                _c("CardItem", {
                  attrs: { title: "End Date", content: _vm.endDate },
                }),
                _c("CardItem", {
                  attrs: { title: "Location", content: _vm.location },
                }),
                _c("CardItem", {
                  attrs: {
                    title: "Employment Type",
                    content: _vm.experience.employment_type,
                  },
                }),
                _c("CardItem", {
                  attrs: { title: "Industry", content: _vm.industry },
                }),
                _c("CardItem", {
                  attrs: {
                    title: "Skills",
                    content: _vm.skills,
                    fullwidth: "",
                  },
                }),
                _c("CardItem", {
                  attrs: {
                    title: "Summary",
                    content: _vm.experience.summary,
                    fullwidth: "",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.isModalOpen
        ? _c("ExperienceModal", {
            attrs: { userId: _vm.userId, experience: _vm.experience },
            on: {
              updated: function ($event) {
                return _vm.$emit("updated")
              },
            },
            model: {
              value: _vm.isModalOpen,
              callback: function ($$v) {
                _vm.isModalOpen = $$v
              },
              expression: "isModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }